import { SimpleBuildingRegistration } from '../../../types/building';
import { FlerboligbyggSummary } from '../../../services/types';
import { Energimerkeversjon } from '../../../types/energimerke';
import { getXmlEnhetPath, getXMLFlerboligPath } from '../../../utils/navigation';

export const getEnkelRegistreringPathByEnergimerkeVersjon = (
  registrering: SimpleBuildingRegistration
): string => {

  const isNewVersion  = registrering.energimerkeVersjon === Energimerkeversjon.V2025;

  if ('registreringId' in registrering) {
    if(isNewVersion) {
      return`json/enhet/oppsummering-av-fil/${registrering.registreringId}`;
    }
    return getXmlEnhetPath({
      registrationId: registrering.registreringId,
      step: 'oppsummering-av-fil'
    })
  }

  throw new Error('Ukjent registreringstype i getEnkelRegistreringPathByEnergimerkeVersjon');
};


export const getFlerboligPathByEnergimerkeVersjon = (
  registrering: FlerboligbyggSummary
): string => {

  const isNewVersion  = registrering.energimerkeVersjon === Energimerkeversjon.V2025;

  if ( 'flerboligbyggId' in registrering ) {
    if(isNewVersion) {
      return `json/flerbolig/oppsummering-av-fil/${registrering.flerboligbyggId}`;
    }
    return getXMLFlerboligPath({
      flerboligId: registrering.flerboligbyggId,
      step: 'oppsummering-av-fil'
    })
  }

  throw new Error('Ukjent registreringstype i getFlerboligPathByEnergimerkeVersjon');
};
